import React, { useState } from 'react';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@dashboard/services/request';
import { apiKeysKey } from '@dashboard/lib/queryKeys';
import Button from '@dashboard/components/Button';
import PageHeader from '@dashboard/components/PageHeader';
import { PlusIcon } from '@heroicons/react/24/outline';
import ApiKeyTable from './components/ApiKeyTable';
import ApiKeyCreateDialog from './components/ApiKeyCreateDialog';
import Link from '@/dashboard/components/Link';

const SettingsApiKeys = () => {
  const [showCreateApiKeyDialog, setShowCreateApiKeyDialog] = useState(false);
  const { sellerId, token } = useAuth();

  const {
    data: apiKeys,
    isLoading: isLoadingApiKeys,
    isError: isErrorApiKeys,
  } = useQuery({
    queryKey: apiKeysKey(sellerId),
    queryFn: () => fetcher(`/sellers/${sellerId}/api-keys`, token),
    enabled: !!sellerId,
  });

  return (
    <div className="p-4 space-y-4">
      <PageHeader
        title="API keys"
        description={
          <>
            Use the API to integrate Checkout Page with your own apps and services.{' '}
            <Link target="_blank" to="/docs/api">
              View documentation
            </Link>
          </>
        }
        actions={
          <Button appearance="primary" onClick={() => setShowCreateApiKeyDialog(true)}>
            Create API key
            <PlusIcon className="w-4 h-4 ml-2 align-baseline" />
          </Button>
        }
      />

      <div className="mb-32">
        <ApiKeyTable data={apiKeys} isLoading={isLoadingApiKeys} isError={isErrorApiKeys} />

        <ApiKeyCreateDialog
          open={showCreateApiKeyDialog}
          onClose={() => setShowCreateApiKeyDialog(false)}
        />
      </div>
    </div>
  );
};

export default SettingsApiKeys;
